import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {AssetsService} from '../../../services/assets.service';
import {UrlParamsService} from '../../../../core/services/impl/url-params.service';
import {isMPay} from '../../../../core/utils/utils';
import {ConfigurationService} from '../../../../core/services/impl/configuration/configuration.service';
import {PartnerService} from '../../../services/partner.service';
import {NotificationBase} from '../../../components/abstract/notification-base';

@Component({
  selector: 'app-error-notification-web',
  templateUrl: './error-notification-web.component.html',
  styleUrls: ['./error-notification-web.component.scss']
})
export class ErrorNotificationWebComponent extends NotificationBase implements OnInit {

  get logoVisible(): boolean {
    return !(isMPay() && this.urlParamsService.isMobileOrigin);
  }

  constructor(private _router: Router,
              urlParamsService: UrlParamsService,
              partnerService: PartnerService,
              private configuration: ConfigurationService,
              private assetsService: AssetsService) {
    super(urlParamsService, partnerService);
    this._router.navigate(['']);
  }

  ngOnInit() {
  }

  refreshApp() {
    if (!this.anchorButton) {
      window.location.reload();
    }
  }

  get informationImage(): string {
    return this.assetsService.informationDialogImageSrc;
  }

  get logoUrl(): string {
    return this.configuration.uiConfig.headerConfig.logo.url;
  }
}
